<div class="unsubscribe-page">
    @if (loading) {
        <div>
            <mat-spinner class="spinner" [diameter]="80"></mat-spinner>
        </div>
    }
    @if (!loading) {
        <div>
            @if (!isHealthRoute) {
                <img alt="" [src]="'assets/logo_envelope.svg'" id="promoImage" />
            }
            @if (email) {
                <div class="header-content">Goodbye!</div>
                <div class="content">
                    {{ email }} has been successfully unsubscribed from marketing emails. You will no longer receive this type of email but
                    if you are opted into appointment reminders, you will continue to receive those email notifications.
                </div>
            } @else if (!isHealthRoute) {
                <div class="header-content">Sorry!</div>
                <div class="content">
                    An error occurred while attempting to unsubscribe your email address. Please try again, or email us at
                    support&#64;daysmart.com if you continue to receive this error.
                </div>
            }
        </div>
    }
</div>
